import './EmptyResults.css'

import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'

function EmptyResults() {
  const { t: translate } = useTranslation()

  return (
    <div className="empty-results">
      <i className="icon no-shops-icon" />
      <div className="empty-results-text">{translate('search.empty')}</div>
    </div>
  )
}

export default memo(EmptyResults)
